<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row class="pa-2" no-gutters v-if="cardTexts && cardTexts.data">
        <v-col
          class="pa-2 mb-4 sticky-md"
          cols="12"
          md="4"
          style="top: 12px"
        ></v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <qr-maker :loading="loading" :svg="svgMade" />
              <v-btn class="btn-download" @click="showDialog = true">
                <v-icon>mdi-progress-download</v-icon>
                {{ $t("download_qr") }}              </v-btn>
            </v-tab-item>

            <v-tab-item>
              <view-menu v-model="cardTexts.data" />
            </v-tab-item>
          </v-tabs-items>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات منو</p>
                </div>
                <div class="col-md-6 mt-0 pt-0">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="cardTexts.data.visitName"
                      :disabled="e6 > 2"
                      append-icon="mdi-pen"
                      class="mt-0 pt-0 contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      label="نام منوی شما"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-data-visitName`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="نام منوی"
                    />
                  </div>
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <!-- <div class="d-flex row">
                <v-btn
                  :disabled="e6 > 1"
                  class="mb-4"
                  color="third"
                  outlined
                  @click="clearDefaults"
                >
                  <v-icon class="me-2">mdi-delete</v-icon>
                  حذف اطلاعات پیشفرض
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-data-clearDefaults`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="حذف اطلاعات پیشفرض"
                />
              </div> -->
              <list-expansion
                v-model="cardTexts.data"
                :components="specialInfo"
                :data="cardTexts.data"
                flat
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr(true);"
                />
              </div>
            </v-stepper-content>
          </v-stepper>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="{ title: 'دانلود کیوآر' }"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download-d`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>
          <v-card class="px-5">
            <download-file
              v-if="showDialog"
              :info="{ theme: '', data: cardTexts }"
              :svg="svgMade"
              :visit-name="cardTexts.visitName"
              destination_url="https://t.qrland.ir/"
            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import ViewMenu from "../otherQrTypes/menu/cm/viewMenu.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import { Bus, debounce } from "@/main";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import PrevBtn from "@/view/content/fragments/prevBtn";
import DownloadFile from "@/view/pages/qrland/downloadFile";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import { mapActions } from "vuex";

export default {
  name: "editMenuModel",

  props:{
    id:{type:String, default:''},
  },

  components: {
    QrCustomize,
    DownloadFile,
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    QrAddressField,
    ViewMenu,
    QrMaker,
  },

  provide() {
    return {
      productImageSize: "128",
      getMenuCurrency: () => this.selectedCurrency
    }
  },
  
  data: () => ({
    selectedCurrency: 'ریال',
    helpData: [],
    serviceName: "Qrland",
    componentName: "editMenu-Model",
    cardTexts: { data: {} }, // اصلاح شد: مقداردهی اولیه برای جلوگیری از خطای undefined
    res: {},
    createdDomain: null,
    createdId: null,
    destinationUrl: "",
    domainId: null,
    dtUrl: null,
    errors: {},
    e6: 1,
    finish: false,
    specialInfo: [
       {
          name: "ThemeSelector2",
          value: "",
          title: "انتخاب دیزاین قالب", // برای i18n می‌توانید از this.$t('select_template_design') استفاده کنید
          subtitle: "",
          icon: "card-account-details-star-outline",
          model: "ThemeSelector2"
        },
        {
          name: "shopLoginConfig",
          value: "",
          title: "تنظیمات ورود", // this.$t("shop.login_settings")
          subtitle: "",
          icon: "home-import-outline",
          model: "shopLoginConfig",
          tabs: [
            {
              title: "عکس های لوگوی فروشگاه", // this.$t("shop.store_logo_images")
              icon: "mdi-cards-playing-heart-outline",
              component: "shopLogo_menu",
              model: "shopLogo",
            },
            {
              title: "اطلاعات صفحه ورود", // this.$t("shop.login_page_info")
              icon: "mdi-view-carousel-outline",
              component: "shopLoginConfig",
              model: "configs",
            },
          ],
        },
        {
          name: "GeneralSettings",
          value: "",
          title: "تنظیمات عمومی منو", // this.$t('general_menu_settings')
          subtitle: "",
          icon: "cog-outline",
          model: "settings"
        },
      {
        name: "bannerSelector",
        value: "",
        title: "آپلود بنر",
        subtitle: "",
        icon: "image-area",
        model: "banner",
      },
      {
        name: "Product",
        value: "",
        title: "ایجاد محصول",
        subtitle: "",
        icon: "sign-yield",
        model: "product",
      },
      {
        name: "textCards",
        value: "",
        title: "اطلاعات کاربری",
        subtitle: "",
        icon: "account-outline",
      },
      {
        name: "socialMediaIcons",
        value: "",
        title: "افزودن شبکه های اجتماعی",
        subtitle: "",
        icon: "instagram",
        model: "socialMedia",
      },
      {
        name: "PicSelector",
        value: "",
        title: "گالری عکس",
        subtitle: "",
        icon: "image-outline",
      },
      {
        name: "VideoGallery",
        value: "",
        title: "گالری ویدئو",
        subtitle: "",
        icon: "video-outline",
      },
      {
        name: "FeedBack",
        value: "",
        title: "بازخورد",
        subtitle: "",
        icon: "reply-outline",
        model: "FeedBack",
      },
      {
        name: "WorkSheet",
        value: "",
        title: "تایم کاری",
        subtitle: "",
        icon: "timetable",
        model: "WorkSheet",
      },
    ],
    svgMade: "",
    showDialog: false,
    loading: false,
    qrShow: 1,
    // اصلاح شد: اضافه کردن ساختار پیش‌فرض برای جلوگیری از ارور
    qrDesign: {
      qrStyleColors: {},
      MarkerCenter: {},
      QrMarkOut: {},
      QrFrame: {},
      LogoImg: {}
    },
  }),

  mounted() {
    this.fetchData();
  },

  watch: {
    // اصلاح شد: مسیر صحیح cardTexts.data.settings.currency
    "cardTexts.data.settings.currency": {
      handler(val) {
        if (!!val) {
          this.selectedCurrency = val;
        }
      },
      immediate: true, 
    },

    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    qrDesign: {
      handler() {
        // اصلاح شد: بررسی وجود متد preview قبل از فراخوانی آن (چون در اینجا وجود نداشت)
        if (this.destinationUrl && typeof this.preview === 'function') {
          debounce(() => {
            this.preview(this.destinationUrl);
          }, 3000);
        }
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    fetchData() {
      this.loading = true;
      this.$api
        .get(`qr/template/${this.id}`)
        .then(({ data }) => {
          this.loading = false;
          this.cardTexts =
            typeof data.data.qr.data === "string"
              ? JSON.parse(data.data.qr.data)
              : data.data.qr.data;
          this.res = data;
          this.setCreatedQrID(data.data.id);
          
          if(!this.cardTexts.data.ThemeSelector2) {
            this.cardTexts.data.ThemeSelector2 = { theme: 'theme_1' };
          }
          if (!this.cardTexts.data.settings) {
            this.cardTexts.data.settings = {
              businessType: 'restaurant',
              showCategories:true,
              currency: 'ریال',
              showFilter: true,
              customLabels: { productsTitle: '', cartButton: '' }
            };
          } else if (!this.cardTexts.data.settings.customLabels) {
            this.cardTexts.data.settings.customLabels = { productsTitle: '', cartButton: '' };
          }
          if (!this.cardTexts.data.shopLoginConfig) {
            this.cardTexts.data.shopLoginConfig = {
              shopLogo: [
                { value: "logo", name: "عکس لوگو", logo: "" },
                { value: "background", name: "عکس پس زمینه", background: "" },
              ],
              configs: { subtitle: "" },
            };
          }
          if (!Object.hasOwn(this.cardTexts.data.product, "onlineShop")) {
            this.cardTexts.data.product.onlineShop = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    markQr(final = false) {
      this.loading = true;
      let obj = {
        type: "menu",
        qrType: "dynamic",
        title: this.cardTexts.data.visitName,
        data: JSON.stringify({
          theme: "",
          data: this.cardTexts.data,
        }),
        qr: {
          section: "#link",
          link: "https://qr2.in/",
          backcolor: "#ffffff",
          frontcolor: "#000000",
          gradient_color: "#000000",
          marker_out_color: "#000000",
          marker_in_color: "#000000",
          marker_top_right_outline: "#000000",
          marker_top_right_center: "#000000",
          marker_bottom_left_outline: "#000000",
          marker_bottom_left_center: "#000000",
          framecolor: "#000000",
          optionlogo: "none",
          "logo-size": 100,
          marker: "default",
          marker_in: "default",
          outer_frame: "none",
          framelabel: "SCAN ME",
          label_font: "AbrilFatface.svg",
          "label-text-size": 100,
          size: "248",
          level: "M",
        },
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .put(`qr/template/${this.id}`, {
          qr: obj,
          type: "menu",
          title: this.cardTexts.data.visitName,
        })
        .then(({ data }) => {
          this.finish = final;
          this.loading = false;
          this.$toast.success("مدل منوی شما با موفقیت بروزرسانی شد.");
          if(!!this.finish)
          this.$router.replace({ name: "modelsList" });
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clearDefaults() {
      this.cardTexts = {
        data: {
          ThemeSelector2: { theme: 'theme_1' },
          shopLoginConfig: {
            shopLogo: [
              { value: "logo", name: "عکس لوگو", logo: "" },
              { value: "background", name: "عکس پس زمینه", background: "" },            
            ],
            configs: { subtitle: "" },
          },
          settings: {
            showFilter: true,
            showCategories: true,
            currency: "ریال", 
            businessType: "restaurant",
            customLabels: { productsTitle: "", cartButton: "" }
          },
          banner: { gallery: [{ name: "", images: [] }] },
          product: {
            title: "محصولات",
            description: "",
            sectionColor: {
              backGround: "linear-gradient(to right , #350808, #1C107CFF)",
              text: "#fff",
            },
            items: [],
          },
          textCards: {
            sectionColor: {
              backGround: "linear-gradient(to bottom , #007376FF, #08004AFF)",
              text: "#fff",
            },
          },
          extraFields: [{ icon: "", name: "", value: "" }],
          socialMedia: {},
          PicSelector: {
            title: null,
            description: null,
            sectionColor: { backGround: "", text: "" },
            slider: true,
          },
          gallery: [],
          VideoGallery: {
            title: "گالری ویدئو",
            description: "برای آشنایی بیشتر با خدمات هوشمند سامانه کیوآرلند، ویدئو های زیر را مشاهده فرمایید.",
            sectionColor: { backGround: "", text: "" },
          },
          video_gallery: [],
          FeedBack: {
            title: "بازخورد شما",
            description: "لطفا با پاسخ گویی به سوالات زیر مارا در خدمات بهتر راهنمایی فرمایید",
            sectionColor: { backGround: "linear-gradient(to right , #FFFFFFFF, #FFFFFFFF)", text: "" },
            type: "text",
            items: [],
          },
          WorkSheet: { items: {} },
          visitName: "",
          organizationName: "",
          subOrgan: "",
          userName: "",
          workField: "",
          phoneNumber: [],
          companyNumber: "",
          email: "",
          fax: "",
          location: "",
          city: "",
          codePostal: "",
          province: "",
          country: "",
          website: "",
          aboutUs: "",
          copyright: "",
          center: [51.44663997885132, 35.74305387731438],
          coordinates: [51.446682645747444, 35.743053507096036],
          address: "",
          pallete: {},
        }
      };
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
